$(function(){
    $(window)
        .load(lateAnimations)
        .scroll(lateAnimations);
})

function lateAnimations(){
    $(".animation-late:not(.enable)").each(function(){
        $(this).isOnScreen(function(o){
            $(o).addClass("enable");
        })
    });
}

$.fn.isOnScreen = function(callback){
    var win = $(window);
    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    var result = (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

    if(result && callback!=null){
        callback(this);
    }

    return result;
};